import { __rest } from "tslib";
import classNames from 'classnames';
import { createElement } from 'rax';
import Text from 'rax-text';
import View from '../../view';
import { isString } from '../../utils';
const ListItemLabel = (props) => {
    const { prefix = 'mt-', className, children } = props, others = __rest(props, ["prefix", "className", "children"]);
    const Wrapper = isString(children) ? Text : View;
    return (<Wrapper {...others} className={classNames(`${prefix}list-item-title`, className)}>
      {children}
    </Wrapper>);
};
export default ListItemLabel;
